export const ACTION_TYPES = {
  GET_CANDIDATE_SCORE: "GET_CANDIDATE_SCORE",
  GET_CANDIDATE_SCORE_SUCCESS: "GET_CANDIDATE_SCORE_SUCCESS",
  GET_CANDIDATE_SCORE_FAILED: "GET_CANDIDATE_SCORE_FAILED"
};
